
import { Component, Vue } from 'vue-property-decorator';
import SysNotice from "@/components/SysNotice/Index.vue";
import {moduleApi, ssoApi} from "@/api/organization";
import ChangeUserPwd from "@/components/sys/ChangeUserPwd.vue";

@Component({
    components: {ChangeUserPwd, SysNotice}
})
export default class Home extends Vue {
    title = "主页内容";
    list = [];
    changeUserPwdDialog = {
      visible: false,
      loginName: ''
    };

    created() {
        this.isExpiredPwd();
        this.getList();
    }
    returnImageUrl(path: string){
        let imageUrl = null;
        try {
            imageUrl = require('../../../static/image/indexPage/' + path); // 尝试加载图片
        } catch (error) {
            console.error('Image not found:', error);
        }
        return imageUrl;
    }
    getList(){
        moduleApi.list().then((r: any) => {
            if (r.data.result === 0) {
                const rData = r.data.data;
                rData.forEach((e: any) => {
                    e.url = e.des;
                    if (e.des.indexOf('http') != -1) {
                        if(e.name === '备案检定'){
                            e.des = '计量检定业务管理系统';
                        } else {
                            e.des = e.name;
                        }
                    }
                })
                this.list = rData;
            }
        })
    }
    isExpiredPwd(){
      debugger;
        // 检查 Session Storage 中是否已经验证过密码过期
        const hasChecked = sessionStorage.getItem('hasCheckedPasswordExpiry');
        
        if (hasChecked == null || hasChecked === '0') {
            ssoApi.isExpiredPwd().then((r: any) => {
              if(r.data.result === 0 && r.data.data.expired){
                const { loginName } = r.data.data;
                this.changeUserPwdDialog.visible = true;
                this.changeUserPwdDialog.loginName = loginName;
              }
              sessionStorage.setItem('hasCheckedPasswordExpiry', "1");
            });
        }
    }
    toPage(item: any){
        const authedUser = this.$store.state.AuthedUser;
      const organizationTypes = [];
      if(authedUser.organizationType){
        organizationTypes.push(...authedUser.organizationType.split(','));
      }
        if(item.des == "开发中"){
            this.$alert('您没有权限访问此模块', '提示', {
                confirmButtonText: '确定'
            });
            return;
        }else if(item.name == '备案检定' && [0, 1].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理计量器具备案、检定等业务，请使用个人账户重新登陆。");
            return;
        }else if(item.name == '备案检定' && [3].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你当前的身份是注册用户，不能办理计量器具备案、检定等业务，请先绑定单位后重新登陆再试。");
            return;
        }else if(item.name == '计量考评员' && [0, 1].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理计量考评员相关业务，请使用个人账户重新登陆。");
            return;
        }else if(item.name == '计量考评员' && [3].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你当前的身份是注册用户，不能办理计量考评员相关业务，请先绑定单位后重新登陆再试。");
            return;
        }else if(item.name == '注册计量师' && [0, 1].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理注册计量师相关业务，请使用个人账户重新登陆。");
            return;
        }else if(item.name == '注册计量师' && [3].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你当前的身份是注册用户，不能办理注册计量师相关业务，请先绑定单位后重新登陆再试。");
            return;
        }else if(item.name == '从业人员' && [0, 1].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理从业人员相关业务，请使用个人账户重新登陆。");
            return;
        }else if(item.name == '从业人员' && [3].indexOf(authedUser.type) > -1){
            this.$message.warning("对不起！你当前的身份是注册用户，不能办理从业人员相关业务，请先绑定单位后重新登陆再试。");
            return;
        }else if(item.name == '从业人员'){
          if(organizationTypes.includes("0001") || organizationTypes.includes("0003") || organizationTypes.includes("0006") ||organizationTypes.includes("0008")){
            window.location.href = "https://im.hebjlzy.com/#/?redirect=/congyerenyuan/self-desc/index&relogin=true";
          }else{
            window.location.href = "https://im.hebjlzy.com/#/?redirect=/congyerenyuan/person-info/index&relogin=true";
          }
        }else if(item.name == '监督管理' && [3].indexOf(authedUser.type) > -1){
          this.$message.warning("对不起！你当前的身份是注册用户，不能办理监督管理相关业务，请先绑定单位后重新登陆再试。");
          return;
        }else if(item.name == '监督管理' && [0, 1].indexOf(authedUser.type) > -1){
          this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理监督管理相关业务，请使用个人账户重新登陆。");
          return;
        }else if(item.name == '评价和确认' && [3].indexOf(authedUser.type) > -1){
          this.$message.warning("对不起！你当前的身份是注册用户，不能办理评价和确认相关业务，请先绑定单位后重新登陆再试。");
          return;
        }else if(item.name == '评价和确认' && [0, 1].indexOf(authedUser.type) > -1){
          this.$message.warning("对不起！你登陆的是单位管理员账户，不能办理评价和确认相关业务，请使用个人账户重新登陆。");
          return;
        }else if(item.name == '监督管理' && (!organizationTypes.includes('0001') && !organizationTypes.includes('0002') && !organizationTypes.includes('0003') && !organizationTypes.includes('0006') && !organizationTypes.includes('0008'))){
          this.$message.warning("对不起！您没有权限办理监督管理相关业务。");
          return;
        }else if(item.url.startsWith("http")){
            //如果描述是http开头，直接跳转
            window.location.href = item.url;
            return;
        }
        this.$router.push('/home/' + item.id);
        // const routeData = this.$router.resolve('/home/' + item.id);
        // window.open(routeData.href, '_blank');
    }
}
